// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"about_landingContainer___sXZt"};